var map = {
	"./core/login/login.module": [
		"./src/app/core/login/login.module.ts",
		"login.module"
	],
	"./core/page-not-found/page-not-found.module": [
		"./src/app/core/page-not-found/page-not-found.module.ts",
		"page-not-found.module"
	],
	"./journals/journals.module": [
		"./src/app/journals/journals.module.ts",
		"journals.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_gendir lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_gendir lazy
// module id = ./src/$$_gendir lazy recursive
// module chunks = main